import { PaginationParams, Review } from "types/general.interface";
import {
  handleDeleteRequest,
  handleGetRequest,
  handlePatchRequest,
  handlePostRequest,
  handlePutRequest,
} from "./http.service";
import { PaginationDataRes } from "types/http.type";
import { Job } from "types/booking.interface";
import { JobCreate, JobQuery, JobStat } from "types/job.interface";

export const getJobs = async (paginationOptions: JobQuery) => {
  return await handleGetRequest<PaginationDataRes<Job[]>>(
    `/admins/jobs?page=${paginationOptions.page}&limit=${
      paginationOptions.limit
    }&status=${paginationOptions.status ?? ""}`
  );
};

export const getJob = async (jobId: string) => {
  return await handleGetRequest<Job>(`/jobs/${jobId}`);
};

export const getJobReviews = async (
  jobId: string,
  params: PaginationParams
) => {
  return await handleGetRequest<PaginationDataRes<Review[]>>(
    `/jobs/${jobId}/reviews?page=${params.page}&limit=${params.limit}`
  );
};

export const editJob = async (jobId: string, payload: JobCreate) => {
  return await handlePutRequest<JobCreate, null>(
    `/admins/jobs/${jobId}`,
    payload
  );
};
export const deleteJob = async (jobId: string) => {
  return await handleDeleteRequest(`/admins/jobs/${jobId}`);
};

export const postJob = async (job: JobCreate) => {
  return await handlePostRequest<JobCreate, Job>(`/admins/jobs`, job);
};

export const getEmployerJobs = async (
  employerId: string,
  paginationOptions: PaginationParams
) => {
  return await handleGetRequest<PaginationDataRes<Job[]>>(
    `/admins/employer-jobs/${employerId}?page=${paginationOptions.page}&limit=${paginationOptions.limit}`
  );
};

export const updateJobStatus = async (
  jobId: string,
  payload: { status: string; comment: string }
) => {
  return await handlePatchRequest<{ status: string; comment: string }, null>(
    `/admins/update-job-status/${jobId}`,
    payload
  );
};

export const getJobStat = async () => {
  return await handleGetRequest<JobStat>(`/admins/job-stats`);
};
